var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"width":"300px","height":"150px","src":_vm.imageURL},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }